<span>
  {{ city }}{{ city === '' || city == null || city === undefined ? '' : ', ' }}{{ state }}
</span>
